import { useState } from "react";
import Navbar from "@/components/Navbar";
import { Button } from "../../components/ui/button";
import Footer from "@/components/Footer";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "Technical Support",
    message: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for reaching out! Our team will get back to you shortly.");
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      {/* Hero */}
      <section className="px-4 sm:px-6 py-16 md:py-24 max-w-7xl mx-auto text-center">
        <h1 className="font-display font-bold text-4xl md:text-5xl text-foreground mb-6 tracking-tight">Get in Touch</h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          Our dedicated support team is here to assist healthcare professionals and patients alike.
          Whether you have technical questions or need help navigating our platform, we're just a message away.
        </p>
      </section>

      {/* Main: Form + Info */}
      <section className="px-4 sm:px-6 pb-20 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8">
        {/* Form */}
        <div className="lg:col-span-7 bg-card p-8 rounded-2xl border border-border">
          <h2 className="font-display font-bold text-2xl text-foreground mb-8">Send a Message</h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-semibold mb-2 text-foreground">Full Name</label>
                <input type="text" name="fullName" placeholder="John Doe" value={formData.fullName} onChange={handleChange} required
                  className="w-full px-4 py-3 rounded-xl bg-muted border border-border focus:border-primary focus:bg-card focus:outline-none transition-all" />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2 text-foreground">Email Address</label>
                <input type="email" name="email" placeholder="john@clinic.com" value={formData.email} onChange={handleChange} required
                  className="w-full px-4 py-3 rounded-xl bg-muted border border-border focus:border-primary focus:bg-card focus:outline-none transition-all" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2 text-foreground">Subject</label>
              <select name="subject" value={formData.subject} onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl bg-muted border border-border focus:border-primary focus:bg-card focus:outline-none transition-all text-foreground">
                <option>Technical Support</option>
                <option>Billing Inquiry</option>
                <option>Partnership</option>
                <option>General Feedback</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2 text-foreground">Message</label>
              <textarea name="message" placeholder="How can we help you today?" rows={6} value={formData.message} onChange={handleChange} required
                className="w-full px-4 py-3 rounded-xl bg-muted border border-border focus:border-primary focus:bg-card focus:outline-none transition-all resize-none" />
            </div>
            <Button type="submit" className="rounded-full h-12 px-8 bg-primary text-primary-foreground hover:bg-[#1a3025] text-base">
              Send Message
            </Button>
          </form>
        </div>

        {/* Info sidebar */}
        <div className="lg:col-span-5 space-y-6">
          <div className="bg-primary text-primary-foreground p-8 rounded-2xl flex items-start gap-6">
            <div className="bg-white/10 p-3 rounded-full shrink-0">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div>
              <h3 className="font-display font-bold text-xl mb-2">Main Office</h3>
              <address className="not-italic text-primary-foreground/80 leading-relaxed">
                Kursoo Raj Bagh Bund<br />
                Srinagar, Jammu and Kashmir 190008
              </address>
            </div>
          </div>

          <div className="bg-card p-8 rounded-2xl border border-border flex items-center gap-6">
            <div className="bg-primary/10 p-3 rounded-full text-primary shrink-0">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-semibold text-muted-foreground">Support Email</p>
              <a href="mailto:info.queuemed@gmail.com" className="font-display font-bold text-lg text-foreground hover:underline">info.queuemed@gmail.com</a>
            </div>
          </div>

          <div className="bg-card p-8 rounded-2xl border border-border flex items-center gap-6">
            <div className="bg-primary/10 p-3 rounded-full text-primary shrink-0">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-semibold text-muted-foreground">Phone Support</p>
              <div className="space-y-1">
                <a href="tel:+917006021273" className="font-display font-bold text-lg text-foreground hover:underline block">+91 70060 21273</a>
                <a href="tel:+917006015229" className="font-display font-bold text-lg text-foreground hover:underline block">+91 70060 15229</a>
              </div>
            </div>
          </div>

          <div className="bg-primary text-primary-foreground p-8 rounded-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display font-bold text-lg">Live Office Status</h3>
              <div className="flex items-center gap-2">
                <span className="w-3 h-3 bg-green-400 rounded-full animate-pulse" />
                <span className="text-sm font-medium">Open Now</span>
              </div>
            </div>
            <p className="text-primary-foreground/70 mb-6">Our team is currently online and responding to inquiries in approximately 15 minutes.</p>
            <div className="h-24 bg-white/5 rounded-xl border border-white/10 flex items-center justify-center italic text-primary-foreground/30">
              Interactive Map Loading…
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="px-4 sm:px-6 py-12">
        <div className="max-w-7xl mx-auto bg-card border border-border rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between">
          <div className="mb-8 md:mb-0 md:mr-8 text-center md:text-left">
            <h2 className="font-display font-bold text-3xl text-foreground mb-3">Subscribe to Health Briefs</h2>
            <p className="text-muted-foreground text-lg">Get the latest healthcare technology updates and clinical efficiency tips delivered to your inbox weekly.</p>
          </div>
          <div className="w-full md:w-auto flex flex-col sm:flex-row gap-4">
            <input type="email" placeholder="doctor@practice.com"
              className="px-6 py-4 rounded-xl bg-muted border border-border focus:border-primary focus:bg-card focus:outline-none transition-all min-w-[280px]" />
            <Button className="rounded-full h-12 px-8 bg-primary text-primary-foreground hover:bg-[#1a3025] whitespace-nowrap">
              Join Now
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
